
const localEnvs = {
  // enable Posthog in development environment
  DEVELOPMENT_ENABLE_POSTHOG: 'false',
  POSTHOG_API_KEY: 'phc_H7jis35kpEnmnsTqoKNFvzfwam4TVLBPJqh4i9Ryz6u'
};

const useEnv = (overrides = {}) => {
  return {
    ...process.env,
    ...localEnvs,
    ...overrides
  };
};

export { useEnv };
